import useEstimateRenewal from "features/subscriptions/datahooks/useEstimateRenewal";

import type { PricingPeriodInfo } from "common/types";

import Price from "./Price";

export default function SubRenewalPrice({
  subscriptionId,
  pricingPeriodInfo,
  isCustomer,
}: {
  pricingPeriodInfo: PricingPeriodInfo;
  subscriptionId: string;
  isCustomer: boolean;
}) {
  const { estimateRenewal, isLoadingEstimateRenewal } = useEstimateRenewal(
    isCustomer ? undefined : subscriptionId,
  );

  return (
    <Price
      estimate={estimateRenewal}
      pricingPeriodInfo={pricingPeriodInfo}
      isLoading={isLoadingEstimateRenewal}
    />
  );
}
